import api from '.';
import { RotateEquipmentListGroup } from '../pages/MasterData/RotateEquipmentListGroup/rotateEquipmentListGroupSlice';

interface ReturnTypeRotateEquipmentListGroup {
  data: RotateEquipmentListGroup[];
}

export async function getRotateEquipmentListGroups(): Promise<ReturnTypeRotateEquipmentListGroup> {
  const { data } = await api.get('/rotate-equipment-list-groups');

  return data;
}
